export const sortByMatchupGrade = (p: { overallGrade: string }) => p.overallGrade
